var _path, _line, _line2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4545 22.8667H2C1.52135 22.8667 1.13333 22.4786 1.13333 22V2C1.13333 1.52135 1.52135 1.13333 2 1.13333H10.9532L13.8545 4.32482L16.3212 7.58082V22C16.3212 22.4786 15.9332 22.8667 15.4545 22.8667Z",
    stroke: "#93A2BA",
    strokeWidth: 2.26667
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.36353,
    y1: 10.1602,
    x2: 11.9999,
    y2: 10.1602,
    stroke: "#93A2BA",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.36353,
    y1: 12.3398,
    x2: 11.9999,
    y2: 12.3398,
    stroke: "#93A2BA",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 17.453H14.7271V21.0033C14.7271 21.1889 14.9581 21.2744 15.0789 21.1334L16.3634 19.6348L17.6479 21.1334C17.7688 21.2744 17.9998 21.1889 17.9998 21.0033V17.453Z",
    fill: "white",
    stroke: "#93A2BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1426 11.0707C15.4958 10.9631 15.858 10.8446 16.2973 10.6468C16.7367 10.8446 17.0989 10.9631 17.4521 11.0707C17.5133 11.0893 17.5736 11.1075 17.6337 11.1256C17.9204 11.2119 18.2009 11.2963 18.536 11.4215C18.7574 11.9131 18.9904 12.299 19.2157 12.645C19.2912 12.761 19.3627 12.8682 19.4312 12.9708C19.5523 13.1523 19.6641 13.3198 19.7725 13.4979C19.4298 14.5097 19.3742 15.1117 19.3427 15.8994C19.031 16.0664 18.7805 16.2175 18.5196 16.4364C18.2381 16.6726 17.9461 16.9867 17.5076 17.473C16.9331 17.3903 16.5294 17.3938 16.1437 17.4276C16.0008 17.4402 15.8754 17.4546 15.7535 17.4686C15.5602 17.4908 15.376 17.512 15.1457 17.5229C14.596 16.8883 14.0665 16.386 13.2524 15.9101C13.2209 15.1171 13.1664 14.5142 12.8222 13.4979C12.9306 13.3198 13.0424 13.1523 13.1635 12.9708C13.232 12.8682 13.3035 12.761 13.379 12.645C13.6043 12.299 13.8373 11.9131 14.0587 11.4215C14.3938 11.2963 14.6743 11.2119 14.9609 11.1256C15.021 11.1075 15.0814 11.0893 15.1426 11.0707Z",
    fill: "white",
    stroke: "#93A2BA",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificates);
export default __webpack_public_path__ + "static/media/Certificates.f4e78fb2.svg";
export { ForwardRef as ReactComponent };